import { request } from '@max/meituan-uni-network';
const isWeb = true;
import { reportJSInfo } from '@max/meituan-uni-report';
import { AntiReqTool } from '@nibfe/h5guard-request';
import { CLIENT_CONTAINER, CLIENT_OS, CLIENT_PLATFORM } from '@lowcode/mcp-protocol/src/base/common';
import { BASE_CLIENT_TYPE, PLATFORM, SOURCE } from '../types/api';
import { getSystemType, SystemType } from '@nibfe/mkt-env-api';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    // PROD: 'http://10.169.86.237:8080/tex2/datacenter/query/simpleShelf/data',
    PROD: 'https://ihotel.meituan.com',
    TEST: 'https://xiongjunjie05-jyzbc-sl-api.hotel.test.meituan.com',
    DEV: 'https://papi.sankuai.com/api/req/55c7984e-3ce0-443d-8313-23dae5d52a9b'
};
export const API_PATH = {
    STATIC_SUPPLY_DELIVERY: '/landing/page/query/simpleShelf/data'
};
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["LOADING"] = 1] = "LOADING";
    RequestStatus[RequestStatus["SUCCESS"] = 2] = "SUCCESS";
    RequestStatus[RequestStatus["ERROR"] = 1] = "ERROR";
})(RequestStatus || (RequestStatus = {}));
const getRequestPlatform = (platform) => {
    let result = PLATFORM.MEITUAN;
    if (platform === CLIENT_PLATFORM.DP) {
        result = PLATFORM.DIANPING;
    }
    return result;
};
const getRequestSource = (clientContainer) => {
    let result = SOURCE.MEITUAN_APP;
    switch (clientContainer) {
        case CLIENT_CONTAINER.DIANPING_APP:
        case CLIENT_CONTAINER.DIANPING_WEBVIEW:
            result = SOURCE.DIANPING_APP;
            break;
        case CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM:
            result = SOURCE.MEITUAN_MINIAPP;
            break;
        case CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM:
            result = SOURCE.HOTEL_MINIAPP;
            break;
        case CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM:
            result = SOURCE.DIANPING_MINIAPP;
            break;
        default:
            break;
    }
    return result;
};
const getRequestClientType = (clientContainer, os) => {
    if ([CLIENT_CONTAINER.MEITUAN_WECHAT_MINI_PROGRAM, CLIENT_CONTAINER.HOTEL_WECHAT_MINI_PROGRAM, CLIENT_CONTAINER.DIANPING_WECHAT_MINI_PROGRAM].indexOf(clientContainer) > -1) {
        return BASE_CLIENT_TYPE.WX;
    }
    if (os === CLIENT_OS.ANDROID) {
        return BASE_CLIENT_TYPE.ANDROID;
    }
    return BASE_CLIENT_TYPE.IPHONE;
};
export const commonParams2RequestParams = (commonParams) => {
    const { userId, token, uuid, platform, appVersion, clientContainer, cityInfo, os, lat = 0, lng = 0 } = commonParams !== null && commonParams !== void 0 ? commonParams : {};
    const isHarmony = getSystemType() === SystemType.harmony;
    let clientType = isHarmony ? BASE_CLIENT_TYPE.HARMONY : getRequestClientType(clientContainer, os);
    const result = {
        userId,
        token,
        platform: getRequestPlatform(platform),
        source: getRequestSource(clientContainer),
        uuid,
        clientVersion: appVersion,
        locationCityId: (cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityId) && Number(cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityId) > 0 ? Number(cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.cityId) : undefined,
        clientType,
        position: `${lng},${lat}`
    };
    return result;
};
export const requestDataCenter = (requestConfig) => {
    const { path, method, params } = requestConfig;
    let finalRequestParams = params;
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            finalRequestParams = antiReq.addCommonParams(finalRequestParams);
        }
        catch (_a) {
            reportJSInfo({
                level: 'info',
                content: '请求加上反爬参数错误',
                secCategory: 'ajaxError'
            }).catch();
        }
    }
    return new Promise((resolve, reject) => {
        request({
            url: `${API_MAP.PROD}${path}`,
            data: Object.assign({}, finalRequestParams),
            method,
            header: {
                'content-type': 'application/json'
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                if (res === null || res === void 0 ? void 0 : res.data) {
                    const templateRes = res === null || res === void 0 ? void 0 : res.data;
                    resolve(templateRes);
                }
                else {
                    reject(new Error(AJAX_ERROR_NAME));
                }
            },
            fail(error) {
                reject(error);
            }
        });
    });
};
